<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="numCarga"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° da Carga</label
              >
            </div>
          </b-col>
          <b-col md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Expedição Inicial"
              v-model="dtIni"
              class="form-control"
              show-decade-nav
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Expedição Final"
              v-model="dtFim"
              class="form-control"
              show-decade-nav
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="numRomaneio"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° Romaneio/MDFE</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="numFiscal"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° da nota</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="emissor"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CNPJ/Razao Social Emissor</label
              >
            </div>
          </b-col>
          <b-col md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Emissão NFE Inicial"
              v-model="dtEmiFiscalIni"
              class="form-control"
              show-decade-nav
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Emissão NFE Final"
              v-model="dtEmiFiscalFim"
              class="form-control"
              show-decade-nav
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="numCte"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° CTE</label
              >
            </div>
          </b-col>
          <b-col md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Emissão CTE Inicial"
              v-model="dtCteIni"
              class="form-control"
              show-decade-nav
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Emissão CTE Final"
              v-model="dtCteFim"
              class="form-control"
              show-decade-nav
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data da Entrega Inicial"
              v-model="dtEntregaIni"
              class="form-control"
              show-decade-nav
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data da Entrega Final"
              v-model="dtEntregaFim"
              class="form-control"
              show-decade-nav
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data da Previsão Inicial"
              v-model="dtPreIni"
              class="form-control"
              show-decade-nav
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data da Previsão Final"
              v-model="dtPreFim"
              class="form-control"
              show-decade-nav
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="motorista"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Motorista(Nome/CPF)</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="placaVeiculo"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Placa do Veículo</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="obs"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Observacao</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="4" class="m-t-5px p-a-0">
            <multiselect
              v-model="transportadora"
              :options-limit="300"
              :limit="2"
              :limit-text="limitText"
              :options="optionsTransportadora"
              track-by="value"
              label="label"
              id="transportadora"
              :hide-selected="true"
              placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
              :searchable="true"
              :loading="isLoadingTransportadora"
              @search-change="listaTransportadora"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="status"
              :options="optionsLivStatus"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="statusAdiantamento"
              :options="optionsLivStatusAdiantamento"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status Adiantamento"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="tpOperacaoPrincipal"
              :options="this.$parent.optionsTpOperacaoPrincipal"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Tipo operação"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-checkbox
                v-model="consulta_completa"
                value="1"
                unchecked-value="2"
            >
              Consulta Completa
              <span
                  v-b-tooltip
                  title="Se marcado irá retornar consulta completa da carga"
                  placement="top"
              >[?]</span
              >
            </b-form-checkbox>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
          <b-col
            class="p-0"
            style="
              display: flex;
              align-items: center;
              margin-left: 5px;
            "
          >
            <AvisoErros
              v-bind:errors_array="this.$parent.errors_array"
            ></AvisoErros>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
import AvisoErros from '../components/AvisoErros';

import { formatCNPJFromParts } from "../utils";

export default {
  components: {
    Multiselect,
    AvisoErros,
  },
  data() {
    return {
      helpForm: new Form({ params: [], search: "" }),
      optionsLivStatus: [],
      optionsLivStatusAdiantamento: [],
      consulta_completa: "",
      numCarga: "",
      dtIni: "",
      dtFim: "",
      numRomaneio: "",
      numFiscal: "",
      dtEmiFiscalIni: "",
      dtEmiFiscalFim: "",
      emissor: "",
      numCte: "",
      dtCteIni: "",
      dtCteFim: "",
      dtEntregaIni: "",
      dtEntregaFim: "",
      dtPreIni: "",
      dtPreFim: "",
      motorista: "",
      placaVeiculo: "",
      obs: "",
      transportadora: "",
      status: "",
      statusAdiantamento: "",
      tpOperacaoPrincipal: "",
      transportadora: [],
      optionsTransportadora: [],
      isLoadingTransportadora: false,
      data_filter: [],
    };
  },
  mounted() {
    this.getStatus();
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.data_filter = {
        numCarga: this.numCarga,
        dtIni: this.formatDateSubmit(this.dtIni),
        dtFim: this.formatDateSubmit(this.dtFim),
        numRomaneio: this.numRomaneio,
        emissor: this.emissor,
        numFiscal: this.numFiscal,
        dtEmiFiscalIni: this.formatDateSubmit(this.dtEmiFiscalIni),
        dtEmiFiscalFim: this.formatDateSubmit(this.dtEmiFiscalFim),
        numCte: this.numCte,
        dtCteIni: this.formatDateSubmit(this.dtCteIni),
        dtCteFim: this.formatDateSubmit(this.dtCteFim),
        dtEntregaIni: this.formatDateSubmit(this.dtEntregaIni),
        dtEntregaFim: this.formatDateSubmit(this.dtEntregaFim),
        dtPreIni: this.formatDateSubmit(this.dtPreIni),
        dtPreFim: this.formatDateSubmit(this.dtPreFim),
        motorista: this.motorista,
        placaVeiculo: this.placaVeiculo,
        obs: this.obs,
        transportadora: this.transportadora,
        status: this.status,
        statusAdiantamento: this.statusAdiantamento,
        tpOperacaoPrincipal: this.tpOperacaoPrincipal,
        consulta_completa: this.consulta_completa,
      };
      this.$events.fire("filter-set", this.data_filter);
    },
    resetFilter() {
      this.numCarga = "";
      this.dtIni = "";
      this.dtFim = "";
      this.emissor = "";
      this.numRomaneio = "";
      this.numFiscal = "";
      this.dtEmiFiscalIni = "";
      this.dtEmiFiscalFim = "";
      this.numCte = "";
      this.dtCteIni = "";
      this.dtCteFim = "";
      this.dtEntregaIni = "";
      this.dtEntregaFim = "";
      this.dtPreIni = "";
      this.dtPreFim = "";
      this.motorista = "";
      this.placaVeiculo = "";
      this.obs = "";
      this.transportadora = "";
      this.status = "";
      this.statusAdiantamento = "";
      this.tpOperacaoPrincipal = "";
      this.consulta_completa = 2;
      this.$events.fire("filter-reset");
    },
    getStatus() {
      this.helpForm.params = { tabela: "carga", coluna: "status" };

      this.helpForm
        .get("/api/listitemvalor/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.items.forEach((obj) => {
            this.optionsLivStatus.push({ label: obj.descr, value: obj.valor });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, false, false);
        });

        this.helpForm.params = { tabela: "despesa_carga", coluna: "status_despesa" };

        this.helpForm
        .get("/api/listitemvalor/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.items.forEach((obj) => {
            this.optionsLivStatusAdiantamento.push({ label: obj.descr, value: obj.valor });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, false, false);
        });
    },
    listaTransportadora(search) {
      if (search.length >= 3) {
        this.isLoadingTransportadora = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/transportadora")
          .then((response) => {
            this.optionsTransportadora = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsTransportadora.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ).replace(
                      /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
                      "$1.$2.$3/$4-$5"
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingTransportadora = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>